import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-types-papi';
import StandardThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard';
import PostEditableItem from '../../../../UserWidgets/_partials/PostEditableItem';
import LoadableDuperbrowseContext from '../../../../../contexts/LoadableDuperbrowseContext';

import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import s from './PostsMobileList.scss';

export interface Props {
  streamId: string;
  items: PapiDeviation[];
}

export class PostsMobileList extends React.Component<Props & WithTranslation> {
  render() {
    const { t, items, streamId } = this.props;
    return (
      <div className={s['root']}>
        <ErrorBoundary>
          <LoadableDuperbrowseContext
            streamId={streamId}
            parent={{ title: t('duperbrowse.backButton.profile.posts') }}
          >
            {items.map((item, i) => (
              <PostEditableItem
                key={`post-${i}-${item.deviationId}`}
                className={s['item']}
                item={item}
              >
                <StandardThumb deviation={item} height={343} />
              </PostEditableItem>
            ))}
          </LoadableDuperbrowseContext>
        </ErrorBoundary>
      </div>
    );
  }
}

export default withTranslation()(PostsMobileList);
